/**
 * @fileoverview This file re-exports all available snippets for the Monaco editor.
 */

export { default as functionDocCompletion } from './FunctionDocCompletion'
export { default as functionCompletion } from './FunctionSnippet'



// WEBPACK FOOTER //
// ./src/components/Editor/monaco-integration/snippets/index.js